import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { CloudDownload, Print } from "@mui/icons-material";
import { Box, Button, Card, FormControlLabel, FormLabel, Grid, Icon, MenuItem, Radio, RadioGroup, styled } from "@mui/material";
import { Loader } from "app/components";
import { getAllProjectLocationListForReports, getAllWorkPlanDetails } from "app/redux/actions/ProjectLocationActions";
import { getAllWorkPlanNosByParam, getContractWorkPlanReport } from "app/redux/actions/ReportsAction";
import { AppConstants } from "app/utils/AppConstants";
import { ServiceUrl } from 'app/utils/Constants';
import { SnackBarProperty } from "app/utils/SnackBarProperty";
import { checkValidation, formatDate } from "app/utils/utils";
import { SimpleCard } from "components";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import moment from "moment";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";


const DecoratedTextField = styled(TextValidator)(() => ({
  width: "100%",
  marginBottom: "16px",
}));

export const ContractWorkPlanReport = () => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isDownloading, setIsDownloading] = useState(false)
  const [isPrinting, setIsPrinting] = useState(false)
  const [constructionNameList, setConstructionNameList] = useState()
  const [projectDetails, setProjectDetails] = useState({})
  const { workPlanList, reportsProjectLocationList } = useSelector((state) => state.projectLocation);
  const [filteredWorkPlanList, setFilteredWorkPlanList] = useState()
  const [reportType, setReportType] = useState('construction')
  const [originalTableData, setOriginalTableData] = useState()
  const [filteredTableData, setFilteredTableData] = useState()
  const [boqList, setBoqList] = useState()
  const [workPlanDates, setWorkPlanDates] = useState()
  const [workPlanNumbers, setWorkPlanNumbers] = useState()
  const [state, setState] = useState({
    project_location_id: '',
    constructionname_id: null,
    boq_name: null,
    workplan_date: null,
    workplan_no: null
  })
  const [workplanConstructionData, setWorkplanConstructionData] = useState([])

  useEffect(() => {
    dispatch(getAllProjectLocationListForReports(showLoader, hideLoader, showToast))
  }, []);

  const showLoader = () => {
    setLoading(true)
  }
  const showToast = (msg) => {
    const key = enqueueSnackbar(msg ?? AppConstants.somethingWentWrong, { variant: 'error' });
    SnackBarProperty.error(key, closeSnackbar);
  }

  const hideLoader = () => {
    setLoading(false)
  }

  const getUniqueArrayOfConstruction = (data) => {
    const unique = [];
    const uniqueIds = new Set();

    data.forEach(item => {
      if (!uniqueIds.has(item.constructionname_id)) {
        uniqueIds.add(item.constructionname_id);
        unique.push({
          constructionName: item.constructionName,
          constructionname_id: item.constructionname_id
        });
      }
    });


    return unique;
  }

  const filterByConstructionNameId = (id) => {
    return originalTableData.filter(item => item?.constructionname_id === id);
  }
  function getUniqueBoqName(data) {
    // data may have .boq_list (new shape) or .data (legacy flat list)
    if (!data) return [];
    if (Array.isArray(data?.boq_list) && data.boq_list.length > 0) {
      return data.boq_list.map(b => b?.boq_name ?? '');
    }
    const itemList = data.data ?? [];
    const boqNames = itemList.map(item => item.boq_name ?? '');
    const uniqueBoqNames = [...new Set(boqNames)];
    return uniqueBoqNames;
  }
  const getUniqueWorkplanDates = (dataList, boqName) => {
    const filtered = dataList.filter(item => item.constructionname_id === state?.constructionname_id);
    const dates = [];

    filtered.forEach((item) => {
      // if new shape with boq_list
      if (Array.isArray(item?.boq_list) && item.boq_list.length > 0) {
        item.boq_list.forEach((boq) => {
          if ((boq?.boq_name ?? '') === (boqName ?? '')) {
            (boq?.data ?? []).forEach((entry) => dates.push(entry.workplan_date));
            // also support item_list shape inside boq
            (boq?.item_list ?? []).forEach((entry) => dates.push(entry.workplan_date));
          }
        });
      } else {
        // legacy flat data
        (item?.data ?? []).forEach((entry) => {
          if ((entry?.boq_name ?? '') === (boqName ?? '')) dates.push(entry.workplan_date);
        });
      }
    });

    const uniqueWorkplanDates = [...new Set(dates)];
    return uniqueWorkplanDates;
  }

  const getWorkPlanNos = (value) => {
    const obj = {
      constructionname_id: state?.constructionname_id,
      boq_name: state?.boq_name,
      workplan_date: value
    }
    setLoading(true)
    getAllWorkPlanNosByParam(obj)?.then(res => {
      setLoading(false)
      if (res?.status < 300 && res?.data?.success) {
        if (res?.data?.obj?.length) {
          setWorkplanConstructionData(res?.data?.obj)
          const uniqueSortedWorkplanNos = [...new Set(res?.data?.obj?.map(item => item.workplan_no))].sort((a, b) => a - b);
          console.log("uniqueSortedWorkplanNos", uniqueSortedWorkplanNos)
          setWorkPlanNumbers(uniqueSortedWorkplanNos)
        }
      }
      else {
        const key = enqueueSnackbar(res?.data?.message, { variant: 'info' });
        SnackBarProperty.info(key, closeSnackbar);
      }
    }).catch(err => {
      setLoading(false)
      showToast("Something went wrong")
    })
  }
  /*
    function getFilteredTableData() {
      return originalTableData.map(item => {
        if (item.constructionname_id === state?.constructionname_id) {
          const filteredData = item.data.filter(entry =>
            entry.boq_name === state?.boq_name &&
            entry.workplan_date === state?.workplan_date &&
            entry.workplan_no === state?.workplan_no
          );
          return {
            ...item,
            data: filteredData
          };
        }
        return item;
      }).filter(item => item.data.length > 0);
    }*/

  useEffect(() => {
    if (workPlanList?.length > 0) {
      setFilteredWorkPlanList(workPlanList)
    }
  }, [workPlanList])

  useEffect(() => {
    if (filteredWorkPlanList && filteredWorkPlanList?.length > 0) {
      if (originalTableData && originalTableData?.length > 0) {
        const duplicateTableData = [...originalTableData]
        duplicateTableData?.forEach((elem) => {
          if (elem?.constructionname_id === state?.constructionname_id) {
            elem.data = filteredWorkPlanList

            // If this construction had boq_list (new shape), rebuild boq_list from filteredWorkPlanList so UI reflects filters
            if (Array.isArray(elem?.boq_list) && elem.boq_list.length > 0) {
              const map = {};
              (filteredWorkPlanList ?? []).forEach((it) => {
                const b = it?.boq_name ?? '';
                if (!map[b]) map[b] = [];
                map[b].push({
                  stage_name: it?.stage_name ?? '',
                  start_date: it?.start_date ?? null,
                  end_date: it?.end_date ?? null,
                  noofdays: it?.noofdays ?? '',
                  workplan_date: it?.workplan_date ?? null,
                  workplan_no: it?.workplan_no ?? '',
                });
              });
              elem.boq_list = Object.keys(map).map((bName) => ({ boq_name: bName, data: map[bName] }));
            }

            const newArr = []
            newArr.push(elem)
            const filteredDates = getUniqueWorkplanDates(newArr, state?.boq_name)
            setWorkPlanDates(filteredDates)
          }
        })
        setOriginalTableData(duplicateTableData)
      }
    }
  }, [filteredWorkPlanList])

  const handleChange = (event, source) => {
    setFilteredTableData([])
    if (event.target.name === "project_location_id") {
      // if(reportType==="construction"){
      state.constructionname_id = null
      state.boq_name = null
      state.workplan_date = null
      state.workplan_no = null
      // }
      setConstructionNameList([])
      setBoqList([])
      setWorkPlanDates([])
      setWorkPlanNumbers([])
      setOriginalTableData([])
      setFilteredTableData()
      setProjectDetails({})
      setFilteredWorkPlanList([])

      const filteredArray = reportsProjectLocationList.filter(project => {
        return project.project_location_id === event.target.value
      });

      state.project_name = filteredArray[0].project_name
      state.project_location_id = filteredArray[0].project_location_id
      state.project_id = filteredArray[0].project_id


      setState({ ...state, [event.target.name]: event.target.value });
      if (reportType === "construction") {
        handleFormSubmit(event.target.value)
      }
    }
    else if (event.target.name === "constructionname_id") {
      setBoqList([])
      setWorkPlanDates([])
      setWorkPlanNumbers([])
      setState({ ...state, [event.target.name]: event.target.value, boq_name: null, workplan_date: null, workplan_no: null });
      const filteredArray = filterByConstructionNameId(event.target.value)
      const boqList = getUniqueBoqName(filteredArray[0])
      setBoqList(boqList)
      setFilteredWorkPlanList([])
    }
    else if (event.target.name === "boq_name") {
      setWorkPlanDates([])
      setWorkPlanNumbers([])
      setFilteredWorkPlanList([])
      setState({ ...state, [event.target.name]: event.target.value, workplan_date: null, workplan_no: null });

      dispatch(getAllWorkPlanDetails("name_id", state?.constructionname_id, event.target.value, showLoader, hideLoader, showToast))
    }
    else if (event.target.name === "workplan_date") {
      setWorkPlanNumbers([])
      setState({ ...state, [event.target.name]: event.target.value, workplan_no: null });
      getWorkPlanNos(event?.target?.value)

    }
    else if (event.target.name === "workplan_no") {
      setState({ ...state, [event.target.name]: event.target.value });
    } else {
      setState({ ...state, [event.target.name]: event.target.value });
    }
  }


  const handleFormSubmit = (project_location_id) => {
    if (state?.constructionname_id && state?.constructionname_id != null && state?.boq_name && state?.workplan_date && state?.workplan_no) {
      const constructionData = transformConstructionData(workplanConstructionData)
      if (constructionData?.length === 0) {
        const key = enqueueSnackbar("No Details Found", { variant: 'info' });
        SnackBarProperty.info(key, closeSnackbar);
      } else {
        setFilteredTableData(constructionData)
      }
    } else {
      setLoading(true)
      getContractWorkPlanReport({ project_location_id: state?.project_location_id ?? project_location_id })
        .then((res) => {
          if (res?.status < 300) {
            if (res?.data?.obj?.item) {
              setProjectDetails({
                company: res?.data?.obj?.agency_name,
                project_name: res?.data?.obj?.item?.project_name,
                project_id: res?.data?.obj?.item?.project_id,
                contractNo: res?.data?.obj?.item?.tender_id,
                workPlanNo: res?.data?.obj?.item?.workorder_no,
                header: res?.data?.obj?.header_logo,
                footer: res?.data?.obj?.footer_logo

              })
            }
            if (res?.data?.obj && res?.data?.obj?.item && res?.data?.obj?.item?.construction_details?.length > 0) {
              const tableDataList = transformProjectData(res?.data?.obj?.item?.construction_details)
              setOriginalTableData(tableDataList)
              if (reportType === "construction") {
                setConstructionNameList(getUniqueArrayOfConstruction(tableDataList))
              }
            } else {
              const key = enqueueSnackbar("No Work Plan Found", { variant: 'info' });
              SnackBarProperty.info(key, closeSnackbar);
            }
          }
          else {
            const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
            SnackBarProperty.error(key, closeSnackbar);
          }
        }).catch(error => {
          const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
          SnackBarProperty.error(key, closeSnackbar);
        }).finally(() => {
          setLoading(false)
        })
    }
  }


  const transformProjectData = (itemList = []) => {
    if (!Array.isArray(itemList)) return [];

    return itemList.map((elem) => {
      const constructionName = elem?.constructionname_name ?? '';
      const constructionname_id = elem?.constructionname_id ?? null;

      // Legacy flat data (if elem.item_list exists)
      const flatData = (elem?.item_list ?? []).map((item, index) => ({
        sl_no: index + 1,
        stage_name: item?.stage_name ?? '',
        start_date: item?.start_date ?? null,
        end_date: item?.end_date ?? null,
        noofdays: item?.noofdays ?? '',
        boq_name: item?.boq_name ?? '',
        workplan_date: item?.workplan_date ?? null,
        workplan_no: item?.workplan_no ?? '',
      }));

      // Build grouped BOQ list. Prefer new shape elem.boq_list; otherwise group flatData by boq_name
      const boq_list = [];

      if (Array.isArray(elem?.boq_list) && elem.boq_list.length > 0) {
        elem.boq_list.forEach((boq) => {
          const boqName = boq?.boq_name ?? '';
          const items = (boq?.item_list ?? []).map((item) => ({
            stage_name: item?.stage_name ?? '',
            start_date: item?.start_date ?? null,
            end_date: item?.end_date ?? null,
            noofdays: item?.noofdays ?? '',
            workplan_date: item?.workplan_date ?? null,
            workplan_no: item?.workplan_no ?? '',
          }));
          boq_list.push({ boq_name: boqName, data: items });
        });
      } else {
        const map = {};
        flatData.forEach((it) => {
          const b = it.boq_name ?? '';
          if (!map[b]) map[b] = [];
          map[b].push(it);
        });
        Object.keys(map).forEach((bName) => {
          boq_list.push({ boq_name: bName, data: map[bName] });
        });
      }

      return {
        constructionName,
        constructionname_id,
        data: flatData,
        boq_list,
      };
    });
  };

  const transformConstructionData = (itemList = []) => {
    if (!Array.isArray(itemList)) return [];

    const rows = [];

    // Case A: itemList is grouped by construction -> boq_list[].item_list[]
    if (itemList.length > 0 && Array.isArray(itemList[0]?.boq_list)) {
      itemList.forEach((construction) => {
        (construction?.boq_list ?? []).forEach((boq) => {
          const boqName = boq?.boq_name ?? '';
          (boq?.item_list ?? []).forEach((it) => {
            rows.push({
              stage_name: it?.stage_name ?? '',
              start_date: it?.start_date ?? null,
              end_date: it?.end_date ?? null,
              noofdays: it?.noofdays ?? '',
              boq_name: boqName,
              workplan_date: it?.workplan_date ?? null,
              workplan_no: it?.workplan_no ?? '',
            });
          });
        });
      });
    }
    // Case B: itemList is array of BOQs (each has item_list)
    else if (itemList.length > 0 && Array.isArray(itemList[0]?.item_list) && itemList[0]?.boq_name) {
      itemList.forEach((boq) => {
        const boqName = boq?.boq_name ?? '';
        (boq?.item_list ?? []).forEach((it) => {
          rows.push({
            stage_name: it?.stage_name ?? '',
            start_date: it?.start_date ?? null,
            end_date: it?.end_date ?? null,
            noofdays: it?.noofdays ?? '',
            boq_name: boqName,
            workplan_date: it?.workplan_date ?? null,
            workplan_no: it?.workplan_no ?? '',
          });
        });
      });
    }
    // Case C: flat list of items (legacy)
    else {
      itemList.forEach((it) => {
        rows.push({
          stage_name: it?.stage_name ?? '',
          start_date: it?.start_date ?? null,
          end_date: it?.end_date ?? null,
          noofdays: it?.noofdays ?? '',
          boq_name: it?.boq_name ?? '',
          workplan_date: it?.workplan_date ?? null,
          workplan_no: it?.workplan_no ?? '',
        });
      });
    }

    return rows.map((row, index) => ({ sl_no: index + 1, ...row }));
  }

  const handleReportDownload = (isPrint) => {
    if (isPrint) {
      setIsPrinting(true)
      setIsDownloading(false)
    }
    else {
      setIsPrinting(false)
      setIsDownloading(true)
    }
    const doc = new jsPDF();
    const headerHeight = checkValidation(projectDetails?.header) ? 35 : 15
    const textX = 15;
    const textY = headerHeight

    const textWidth = doc.getStringUnitWidth("Project Name:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
    // Add the text content below the header image
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold'); // Set font to bold
    doc.text(`Contract Work Plan`, (doc.internal.pageSize.getWidth() / 2) - ((doc.getStringUnitWidth(`Contract Work Plan`) * doc.internal.getFontSize() / doc.internal.scaleFactor) / 2), textY);
    doc.setFontSize(8); // Set font size
    doc.text("Project Name:", textX, textY + 10);

    doc.setFont('helvetica', 'normal');
    doc.text(projectDetails?.project_name, textX + textWidth - 5, textY + 10);
    doc.setFont('helvetica', 'bold');
    doc.text("Client:", textX, textY + 15);
    doc.setFont('helvetica', 'normal');
    doc.text(projectDetails?.company, textX + textWidth - 5, textY + 15);
    doc.setFont('helvetica', 'bold');
    doc.text("Project ID:", textX, textY + 20);
    doc.setFont('helvetica', 'normal');
    doc.text(`${projectDetails?.project_id}`, textX + textWidth - 5, textY + 20);

    const headerSectionHeight = headerHeight + 35; // Adjust the value as needed

    // Calculate the starting Y-coordinate for the table
    const tableStartY = headerSectionHeight + 5;
    doc.setFont('helvetica', 'normal'); // Reset font to normal

    function transformData(data) {
      const transformedData = [];

      if (!Array.isArray(data)) return transformedData;

      const cellStyle = { fontSize: 8 };

      if (reportType === "construction") {
        let overallIndex = 1;

        data.forEach((row) => {
          transformedData.push([
            { content: overallIndex++, styles: cellStyle },
            { content: row?.stage_name ?? "", styles: cellStyle },
            { content: formatDate(row?.start_date), styles: cellStyle },
            { content: formatDate(row?.end_date), styles: cellStyle },
            { content: row?.noofdays ?? "", styles: cellStyle },
          ]);
        });
      } else {
        // Grouped/Sectioned List (Project-level) - support boq_list grouping
        data.forEach((section) => {
          // 1. Add section header row (Construction Name)
          transformedData.push([
            {
              content: section?.constructionName ?? "",
              colSpan: 6,
              styles: { fontStyle: "bold", fontSize: 8, textColor: [138,43,226] },
            },
          ]);

          // 2. If boq_list exists, render BOQ headers and their items
          if (Array.isArray(section?.boq_list) && section.boq_list.length > 0) {
            section.boq_list.forEach((boq) => {
              // BOQ header row
              transformedData.push([
                {
                  content: boq?.boq_name ?? "",
                  colSpan: 6,
                  styles: { fontStyle: "bold", fontSize: 8, textColor: [0,0,255] },
                },
              ]);

              // Items under this BOQ
              (boq?.data ?? []).forEach((row, index) => {
                transformedData.push([
                  { content: index + 1, styles: cellStyle },
                  { content: row?.stage_name ?? "", styles: cellStyle },
                  { content: boq?.boq_name ?? "", styles: cellStyle },
                  { content: formatDate(row?.start_date), styles: cellStyle },
                  { content: formatDate(row?.end_date), styles: cellStyle },
                  { content: row?.noofdays ?? "", styles: cellStyle },
                ]);
              });
            });
          } else {
            // Fallback: render legacy flat data under the construction
            (section?.data ?? []).forEach((row, index) => {
              transformedData.push([
                { content: index + 1, styles: cellStyle },
                { content: row?.stage_name ?? "", styles: cellStyle },
                { content: row?.boq_name ?? "", styles: cellStyle },
                { content: formatDate(row?.start_date), styles: cellStyle },
                { content: formatDate(row?.end_date), styles: cellStyle },
                { content: row?.noofdays ?? "", styles: cellStyle },
              ]);
            });
          }
        });
      }

      return transformedData;
    }

    const transformedData = transformData(filteredTableData);


    doc.autoTable({
      margin: {
        top: 30,      // push below header
        bottom: 30    // leave space above footer
      },
      startY: tableStartY,
      head: reportType === "construction" ? [[
        { content: "SL NO.", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
        { content: "Stage Name", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
        { content: "Start Date", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
        { content: "End Date", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
        { content: "No. of days", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } }
      ]] : [[
        { content: "SL NO.", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
        { content: "Stage Name", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
        { content: "BOQ Name", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
        { content: "Start Date", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
        { content: "End Date", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
        { content: "No. of days", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } }
      ]],
      body: transformedData, // Use the transformed data here
      theme: "grid",
      styles: {
        fillColor: [255, 255, 255], // Remove background color from the table
        lineColor: [0, 0, 0], // Set border color for main table
        lineWidth: 0.1, // Set border width for main table
        textColor: [0, 0, 0], // Set text color to black
        cellPadding: 2, // Add padding to cells
      },
      columnStyles: {
        1: { cellWidth: 80 },
        2: { halign: "center" },
        3: { halign: "center" },
        //   3: { halign: "right" }, // "UNIT" column width
      },
    });


    const totalNumPages = doc.internal.getNumberOfPages();

    // Loop through each page to add the footer with page numbers
    for (let i = 1; i <= totalNumPages; i++) {

      const pdfWidth = doc.internal.pageSize.getWidth() - 30;

      // Header
      const headerHeight = 20;
      const headerX = 15;
      const headerY = 0; // at the very top
      if (checkValidation(projectDetails?.header)) {
        doc.addImage(
          `${ServiceUrl?.showImageUrl}${projectDetails?.header}`,
          headerX,
          headerY,
          pdfWidth,
          headerHeight
        );
      }

      //Footer
      const footerX = 15; // Starting X position for the footer
      const footerY = doc.internal.pageSize.getHeight() - 20; // 10 units from the bottom
      const footerHeight = 20;
      doc.setPage(i);
      if (checkValidation(projectDetails?.footer)) {
        doc.addImage(`${ServiceUrl?.showImageUrl}${projectDetails?.footer}`, footerX, footerY, pdfWidth, footerHeight)
      }
    }

    const scaleFactor = 1.0; // Adjust this value as needed
    const pdfBlob = doc.output('blob', { scale: scaleFactor });

    // Create a URL for the Blob
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open a new window with the PDF URL

    if (isPrint) {
      const newWindow = window.open(pdfUrl, '_blank');

      // After the new window is opened, you can close the URL object
      URL.revokeObjectURL(pdfUrl);
      if (newWindow) {
        newWindow.onload = () => {
          setIsPrinting(false)
          setIsDownloading(false)
          // Wait for the window to load and then trigger the print dialog
          newWindow.print();
        };
      }
    }

    setIsPrinting(false)
    setIsDownloading(false)

    isPrint === false && doc.save('Contract_Work_Plan_Report.pdf');
  };


  useEffect(() => {
    if (reportType === "project" && originalTableData && originalTableData?.length > 0) {
      setFilteredTableData(originalTableData)
    }
  }, [originalTableData])

  return (
    <>
      <div style={{ height: 'auto', width: "100%", padding: '30px', display: "flex", flexDirection: "column", gap: "20px" }}>

        <Grid container>

          <Grid item xs={12}>
            <Button
              size="small"
              sx={{ width: "100px" }}
              variant="contained"
              color="error"
              onClick={() => { window.history.back() }}
            >
              <Icon color="primary" fontSize="small">
                skip_previous
              </Icon>
              Back
            </Button>
          </Grid>
        </Grid>
        <SimpleCard>
          <ValidatorForm onSubmit={handleFormSubmit}>
            <Grid container spacing={3} style={{ marginTop: '-45px', marginBottom: '15px' }} >
              <Grid item xs={12}><b className="font20 extraBold" style={{ color: "#ebad4e" }}>Work Plan (Contract)</b></Grid>
            </Grid>
            <Grid container spacing={3} >
              <Grid item xs={12}>
                <RadioGroup
                  row
                  name="reportType"
                  value={reportType}
                  onChange={(e) => { setReportType(e.target.value); setOriginalTableData(); setFilteredTableData(); e.target.value === "project" && setConstructionNameList(); e.target.value === "project" && setState({ project_location_id: null }); setState({ ...state, constructionname_id: null, project_location_id: null }) }}
                >&nbsp;&nbsp;
                  <FormControlLabel
                    label="Construction Name Level"
                    value="construction"
                    control={<Radio size="small" color="secondary" />}
                    sx={{ height: 20 }}
                  />
                  <FormControlLabel
                    label="Project Level"
                    value="project"
                    control={<Radio size="small" color="secondary" />}
                    sx={{ mr: 3, height: 20 }}
                  />

                </RadioGroup>

              </Grid>
              <Grid item sm={4} xs={12}>
                <DecoratedTextField
                  select
                  size="small"
                  fullWidth
                  sx={{ mb: 3 }}
                  label="Project ID"
                  id="project_location_id"
                  variant="outlined"
                  name="project_location_id"
                  value={state?.project_location_id}
                  onChange={handleChange}
                  validators={["required"]}
                  errorMessages={["Project ID is required"]}
                >
                  {reportsProjectLocationList?.map((item) => (
                    <MenuItem value={item?.project_location_id} key={item?.project_id}>
                      {item?.project_id}
                    </MenuItem>
                  ))}
                </DecoratedTextField>
              </Grid>
              {reportType === "construction" &&
                <>
                  <Grid item sm={4} xs={12}>
                    <DecoratedTextField
                      select
                      size="small"
                      fullWidth
                      sx={{ mb: 3 }}
                      label="Construction Name"
                      id="constructionname_id"
                      variant="outlined"
                      name="constructionname_id"
                      value={state?.constructionname_id}
                      onChange={handleChange}
                      validators={["required"]}
                      errorMessages={["Construction Name is required"]}
                    >
                      {constructionNameList?.map((item) => (
                        <MenuItem value={item?.constructionname_id} key={item?.constructionname_id}>
                          {item?.constructionName}
                        </MenuItem>
                      ))}
                    </DecoratedTextField>
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <DecoratedTextField
                      select
                      size="small"
                      fullWidth
                      sx={{ mb: 3 }}
                      label="BOQ Name"
                      id="boq_name"
                      variant="outlined"
                      name="boq_name"
                      value={state?.boq_name}
                      onChange={handleChange}
                      validators={["required"]}
                      errorMessages={["BOQ Name is required"]}
                    >
                      {boqList?.map((item) => (
                        <MenuItem value={item} key={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </DecoratedTextField>
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <DecoratedTextField
                      select
                      size="small"
                      fullWidth
                      sx={{ mb: 3 }}
                      label="Work Plan Date"
                      id="workplan_date"
                      variant="outlined"
                      name="workplan_date"
                      value={state?.workplan_date}
                      onChange={handleChange}
                      validators={["required"]}
                      errorMessages={["Work Plan Date is required"]}
                    >
                      {workPlanDates?.map((item) => (
                        <MenuItem value={item} key={item}>
                          {moment(item)?.format("DD-MM-YYYY")}
                        </MenuItem>
                      ))}
                    </DecoratedTextField>
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <DecoratedTextField
                      select
                      size="small"
                      fullWidth
                      sx={{ mb: 3 }}
                      label="Work Plan No."
                      id="workplan_no"
                      variant="outlined"
                      name="workplan_no"
                      value={state?.workplan_no}
                      onChange={handleChange}
                      validators={["required"]}
                      errorMessages={["Work Plan No. is required"]}
                    >
                      {workPlanNumbers?.map((item) => (
                        <MenuItem value={item} key={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </DecoratedTextField>
                  </Grid>
                </>
              }

              <Grid item sm={4} xs={12}>


                <Button size="medium" color="success" variant="contained" type="submit" style={{ marginLeft: 4 }} >View</Button>

              </Grid>

            </Grid>

          </ValidatorForm>
        </SimpleCard>
        {filteredTableData && filteredTableData?.length > 0 &&
          <Grid container>
            <Grid xs={12} md={6}>
              {/* {checkValidation(projectDetails?.header)===false&&<FormLabel sx={{color:"#ff9800"}} color="warning">! Please upload header and footer for download/print</FormLabel>} */}
            </Grid>
            <Grid item xs={12} md={6}>
              <Box component="span" display="flex" justifyContent="flex-end">
                <Button
                  size="small"
                  // disabled={projectDetails?.header?false:true}
                  sx={{ width: "130px", marginLeft: 4 }}
                  variant="contained"
                  color="warning"
                  startIcon={<CloudDownload />}
                  onClick={() => { handleReportDownload(false) }}
                >
                  Download
                </Button>
                <Button
                  size="small"
                  // disabled={projectDetails?.header?false:true}
                  sx={{ width: "100px", marginLeft: 2 }}
                  variant="contained"
                  color="primary"
                  startIcon={<Print />}
                  onClick={() => { handleReportDownload(true) }}
                >
                  Print
                </Button>
              </Box>
            </Grid>

          </Grid>}
        {filteredTableData && filteredTableData?.length > 0 && <Card sx={{ padding: 3 }}>

          <div style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px" }}>
            <div id="header" style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px", paddingLeft: "100px", paddingRight: "100px" }}>
              <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "20px", alignItems: "center" }}>
                {checkValidation(projectDetails?.header) &&
                  <img id="headerLogo" src={`${ServiceUrl?.showImageUrl}${projectDetails?.header}`} style={{ height: "150px", width: "auto" }} alt="img" />
                }
              </div>

              <Grid container >
                <Grid item xs={12} align='center' >
                  <FormLabel sx={{ fontSize: 22 }} ><b>CONTRACT WORK PLAN</b></FormLabel>
                </Grid>
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Project Name: </b>{projectDetails?.project_name}</FormLabel>
                </Grid>
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Client: </b>{projectDetails?.company}</FormLabel>
                </Grid>
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Project ID: </b>{projectDetails?.project_id}</FormLabel>
                </Grid>


              </Grid>
            </div>

            <div id="originalTableData">
              <TableContainer component={Paper}>
                <Table>
                  <TableHead style={{ backgroundColor: '#87CEEB' }}>
                    <TableRow>
                      <TableCell>SL No.</TableCell>
                      <TableCell>Stage Name</TableCell>
                      {reportType === "project" && <TableCell>BOQ Name</TableCell>}
                      <TableCell>Start Date</TableCell>
                      <TableCell>End Date</TableCell>
                      <TableCell>No. of days</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reportType === "construction" ? (
                      // Flat Array Rendering for Construction
                      filteredTableData?.map((row, index) => (
                        <TableRow key={row?.id || index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row?.stage_name}</TableCell>
                          <TableCell>{formatDate(row?.start_date)}</TableCell>
                          <TableCell>{formatDate(row?.end_date)}</TableCell>
                          <TableCell>{row?.noofdays}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      // Section-Wise Rendering for Project Level: Construction -> BOQ -> Items
                      filteredTableData?.map((section, sectionIndex) => (
                        <React.Fragment key={section?.constructionName || sectionIndex}>
                          {/* Construction Header */}
                          <TableRow>
                            <TableCell colSpan={6}>
                              <b style={{ color: '#8A2BE2' }}>{section?.constructionName}</b>
                            </TableCell>
                          </TableRow>

                          {/* BOQ groups under this construction */}
                          {(section?.boq_list ?? []).length > 0 ? (
                            section.boq_list.map((boq, boqIndex) => (
                              <React.Fragment key={boq?.boq_name || boqIndex}>
                                {/* BOQ Header */}
                                <TableRow>
                                  <TableCell colSpan={6}>
                                    <b style={{ marginLeft: 10, color: '#0000FF' }}>{boq?.boq_name}</b>
                                  </TableCell>
                                </TableRow>

                                {/* Items under BOQ */}
                                {(boq?.data ?? []).map((row, index) => (
                                  <TableRow key={row?.id || index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{row?.stage_name}</TableCell>
                                    {reportType === "project" && <TableCell>{boq?.boq_name}</TableCell>}
                                    <TableCell>{formatDate(row?.start_date)}</TableCell>
                                    <TableCell>{formatDate(row?.end_date)}</TableCell>
                                    <TableCell>{row?.noofdays}</TableCell>
                                  </TableRow>
                                ))}
                              </React.Fragment>
                            ))
                          ) : (
                            // Fallback: if no boq_list, render items from section.data
                            section?.data?.map((row, index) => (
                              <TableRow key={row?.id || index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{row?.stage_name}</TableCell>
                                {reportType === "project" && <TableCell>{row?.boq_name}</TableCell>}
                                <TableCell>{formatDate(row?.start_date)}</TableCell>
                                <TableCell>{formatDate(row?.end_date)}</TableCell>
                                <TableCell>{row?.noofdays}</TableCell>
                              </TableRow>
                            ))
                          )}
                        </React.Fragment>
                      ))
                    )}

                  </TableBody>
                </Table>
              </TableContainer>

            </div>
          </div>
        </Card>}

      </div>
      {loading && (
        <Loader
          show={loading}
        />
      )}
      {(isPrinting || isDownloading) && (
        <Loader
          show={isPrinting ? isPrinting : isDownloading}
          text="Processing...Please wait."
        />
      )}

    </>
  )
}